var _rect, _path, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCcTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 20,
    viewBox: "0 0 70 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 69.7362,
    height: 20,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1073 4.21103L13.2438 15.8164H10.0694L7.67771 6.5556C7.53047 5.98449 7.40463 5.77666 6.96314 5.53414C6.23993 5.14315 5.05034 4.7764 4 4.54795L4.07351 4.2111H9.18072C9.83208 4.2111 10.4177 4.64556 10.5649 5.39452L11.8296 12.1115L14.9531 4.2111H18.1073V4.21103ZM30.5414 12.0256C30.5555 8.96432 26.3054 8.79771 26.336 7.42815C26.3442 7.01009 26.7405 6.56772 27.6082 6.45604C28.0391 6.39871 29.2249 6.35669 30.569 6.97373L31.0957 4.51385C30.3726 4.25137 29.4431 4 28.2878 4C25.3206 4 23.2318 5.57826 23.2141 7.83648C23.1947 9.5064 24.7044 10.4383 25.8432 10.9945C27.0126 11.5635 27.4036 11.9269 27.3994 12.4372C27.3918 13.2162 26.4664 13.5566 25.6033 13.5719C24.0936 13.5954 23.2179 13.1639 22.5186 12.8382L21.975 15.3827C22.6755 15.7043 23.9724 15.9835 25.3147 16C28.4683 15.9999 30.5314 14.4384 30.5414 12.0256ZM38.3771 15.8165H41.1544L38.731 4.2111H36.1671C35.591 4.2111 35.1053 4.54708 34.8889 5.0618L30.3867 15.8165H33.538L34.1635 14.0833H38.0155L38.3771 15.8165ZM35.0271 11.7046L36.6081 7.34694L37.5176 11.7046H35.0271ZM22.3976 4.21103L19.9136 15.8164H16.9109L19.3954 4.21103H22.3976Z",
    fill: "#1A2ADF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.7363,
    cy: 10,
    r: 7,
    fill: "#F79E1C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.1543,
    cy: 10,
    r: 7,
    fill: "#EA001B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4445 15.5299C56.0929 14.2493 57.1536 12.2479 57.1536 9.99884C57.1536 7.74977 56.0929 5.74844 54.4445 4.46777C52.796 5.74844 51.7354 7.74977 51.7354 9.99884C51.7354 12.2479 52.796 14.2493 54.4445 15.5299Z",
    fill: "#FF5F01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcTagIcon);
export default __webpack_public_path__ + "static/media/cc-tag-icon.94b396bc2fb7f29255b193fcd5bcecc4.svg";
export { ForwardRef as ReactComponent };